import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Http from "../../Common/Http";
import IsLogin from "../../Common/IsLogin";
import { LoaderComponent } from "../../Common/LoaderComponent";

const Reports = () => {
  const [active, setActive] = useState(window.location.pathname);
  const [receiveData, setReceiveData] = useState([]);
  const location = useLocation();

  useEffect(() => {
    if (location.pathname !== "/" && location.pathname !== "/login") {
      fetchData();
    }
  }, [location.pathname]);

  const fetchData = () => {
    Http.get("/login-staff-detail").then((res) => {
      setReceiveData(res.data);
    });
  };

  if (location.pathname === "/" || location.pathname === "/login") return null;

  return (
    <div>
      <IsLogin></IsLogin>
      {/* <LoaderComponent /> */}
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Reports</h5>
        </div>
        {/* am-pagetitle */}
        <div className="am-pagebody" style={{ minHeight: "80vh" }}>
          <div className="row row-sm mg-t-15 mg-sm-t-20">

            <div className="col-md-6">
              <div className="card bd-0">
                <div className="card-header card-header-default bg-primary">
                  Accounts Reports
                </div>
                <div className="card-body bd bd-t-0 rounded-bottom">
                  <div className="report_style">
                    <div className="report-item">
                      <Link to="/cash-flow-statement">
                        <i className="fa fa-globe" aria-hidden="true"></i>
                        <span>Cash Flow Statement</span>
                      </Link>
                    </div>
                    <div className="report-item">
                      <Link
                        to="/reports/financial-summary"
                        className={`nav-link ${active === "/reports/financial-summary"
                            ? "active"
                            : ""
                          }`}
                        onClick={() => setActive("/reports/financial-summary")}
                      >
                        <i className="fa fa-globe" aria-hidden="true"></i>
                        &nbsp;&nbsp; Daily Cash Statement
                      </Link>
                    </div>

                    <div className="report-item">
                      <Link
                        to="/reports/deposit-categories-ledger"
                        className={`nav-link ${active === "/reports/deposit-categories-ledger"
                            ? "active"
                            : ""
                          }`}
                        onClick={() =>
                          setActive("/reports/deposit-categories-ledger")
                        }
                      >
                        <i className="fa fa-globe" aria-hidden="true"></i>
                        &nbsp;&nbsp; Deposit Categories Ledger
                      </Link>
                    </div>
                    <div className="report-item">
                      <Link
                        to="/reports/expense-categories-ledger"
                        className={`nav-link ${active === "/reports/expense-categories-ledger"
                            ? "active"
                            : ""
                          }`}
                        onClick={() =>
                          setActive("/reports/expense-categories-ledger")
                        }
                      >
                        <i className="fa fa-globe" aria-hidden="true"></i>
                        &nbsp;&nbsp; Expense Categories Ledger
                      </Link>
                    </div>
                    <div className="report-item">
                      <Link to="/reports/get-bank-ledger-summary">
                        <i className="fa fa-globe" aria-hidden="true"></i>
                        <span>Bank Ledger Summary</span>
                      </Link>
                    </div>
                    <div className="report-item">
                      <Link to="/reports/vendor-ledger">
                        <i className="fa fa-globe" aria-hidden="true"></i>
                        <span>Vendor Ledger</span>
                      </Link>
                      <Link to="/reports/vendor-ledger-summary">
                        <i className="fa fa-globe" aria-hidden="true"></i>
                        <span>Vendor Ledger Summary</span>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="card bd-0">
                <div className="card-header card-header-default bg-primary">
                  Supply Chain Reports
                </div>
                <div className="card-body bd bd-t-0 rounded-bottom">
                  <div className="report_style">
                    <div className="report-item">
                      <Link
                        to="/production-wise-stock"
                        className={`nav-link ${active === "/production-wise-stock" ? "active" : ""
                          }`}
                        onClick={() => setActive("/production-wise-stock")}
                      >
                        <i className="fa fa-globe"></i>
                        &nbsp;&nbsp; Kitchen wise stock
                      </Link>
                    </div>
                    <div className="report-item">
                      <Link
                        to="/handi-wise-stock"
                        className={`nav-link ${active === "/handi-wise-stock" ? "active" : ""
                          }`}
                        onClick={() => setActive("/handi-wise-stock")}
                      >
                        <i className="fa fa-globe"></i>
                        &nbsp;&nbsp; Handi wise stock
                      </Link>
                    </div>

                    <div className="report-item">
                      <Link
                        to="/handi-rcv-vs-pos-sales-report"
                        className={`nav-link ${active === "/handi-rcv-vs-pos-sales-report"
                            ? "active"
                            : ""
                          }`}
                        onClick={() =>
                          setActive("/handi-rcv-vs-pos-sales-report")
                        }
                      >
                        <i className="fa fa-globe"></i>
                        &nbsp;&nbsp; Handi Rcv Vs POS Sales
                      </Link>
                    </div>
                    <div className="report-item">
                      <Link
                        to="/requisition-vs-production"
                        className={`nav-link ${active === "/requisition-vs-production"
                            ? "active"
                            : ""
                          }`}
                        onClick={() => setActive("/requisition-vs-production")}
                      >
                        <i className="fa fa-globe"></i>
                        &nbsp;&nbsp; Requisition Vs Production
                      </Link>
                    </div>
                    <div className="report-item">
                      <Link
                        to="/product-wise-stock"
                        className={`nav-link ${active === "/product-wise-stock"
                            ? "active"
                            : ""
                          }`}
                        onClick={() => setActive("/product-wise-stock")}
                      >
                        <i className="fa fa-globe"></i>
                        &nbsp;&nbsp; Product Wise Stock Report
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="card bd-0">
                <div className="card-header card-header-default bg-primary">
                  Department wise Reports
                </div>
                <div className="card-body bd bd-t-0 rounded-bottom">
                  <div className="report_style">
                    <div className="report-item">
                      <Link
                        to="/reports/date-wise-issue-out-report"
                        className={`nav-link ${active === "/reports/date-wise-issue-out-report" ? "active" : ""
                          }`}
                        onClick={() => setActive("/reports/date-wise-issue-out-report")}
                      >
                        <i className="fa fa-globe"></i>
                        &nbsp;&nbsp; Department wise Issue Out Report
                      </Link>
                    </div>
                    <div className="report-item">
                      <Link
                        to="/reports/product-wise-purchase-in-report"
                        className={`nav-link ${active === "/reports/product-wise-purchase-in-report" ? "active" : ""
                          }`}
                        onClick={() => setActive("/reports/product-wise-purchase-in-report")}
                      >
                        <i className="fa fa-globe"></i>
                        &nbsp;&nbsp; Product Wise Purchase / In Report
                      </Link>
                    </div>

                    <div className="report-item">
                      <Link
                        to="/reports/product-wise-issue-out-report"
                        className={`nav-link ${active === "/reports/product-wise-issue-out-report"
                            ? "active"
                            : ""
                          }`}
                        onClick={() =>
                          setActive("/reports/product-wise-issue-out-report")
                        }
                      >
                        <i className="fa fa-globe"></i>
                        &nbsp;&nbsp; Product Wise Issue / Out Report
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* row */}
        </div>
      </div>
      {/* am-mainpanel */}
    </div>
  );
};

export default Reports;
